import axios from "axios";
import "./PaymentOption.css";
import Modal from "react-modal";
import validator from 'validator';
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import { Column } from "primereact/column";
import Bac from "../../../images/logo/bac.svg";
import { DataTable } from "primereact/datatable";
import Wise from "../../../images/logo/wise.svg";
import Citi from "../../../images/logo/citi.svg";
import Hsbc from "../../../images/logo/hsbc.svg";
import Bank from "../../../images/icons/bank.svg";
import Type from "../../../images/icons/type.svg";
import React, { useState, useRef, useEffect } from "react";
import Chase from "../../../images/logo/chase.svg";
import Close from "../../../images/icons/close.svg";
import Delete from "../../../images/icons/delete.svg";
import WebPage from "../../../images/icons/webpage.svg";
import crssrImage from "../../../images/icons/close.svg";
import Location from "../../../images/icons/location.svg";
import PlusIcon from "../../../images/icons/plus-icon.svg";
import WiseSmall from "../../../images/icons/wise-small.svg";
import CompanyType from "../../../images/icons/company-type.svg";
import BankAmerica from "../../../images/logo/bank-of-america.svg";
import { useQuery } from 'react-query';
import BankAccount from "../BankAccount/BankAccount";

const PaymentOption = () => {

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingDetails, setIsLoadingDetails] = useState({});
  const [loadingProfiles, setLoadingProfiles] = useState({});
  const [profiles, setProfiles] = useState([]);
  const [filter, setFilter] = useState("");
  const [activeProfiles, setActiveProfiles] = useState([]);
  const [listUpdate, setListUpdaete] = useState(false);
  const [newBankModal, setNewBankModel] = useState(false);
  const [stepTwo, setStepTwo] = useState(false);
  const [setApiKey, setSetApiKey] = useState("");
  const [url, setUrl] = useState("https://api.transferwise.com");
  const [isValid, setIsValid] = useState(true);
  const [urlError, setUrlError] = useState(false);
  const [apiKeyError, setApiKeyError] = useState(false);
  const [selectedGateways, setSelectedGateways] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const token = useSelector(
    (state) => state.auth.token
  );
  const appId = useSelector(
    (state) => state.appSettings.appSettings.appId
  );
  const { appSettings } = useSelector((state) => state.appSettings);
  const [perPage, setPerPage] = useState(10);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isButtonLoading, seIsButtonLoading] = useState(false);
  const [revealModal, setRevealModal] = useState(false);
  const [revealSettingsId, setRevealSettingsId] = useState(null);
  const [revealPassword, setRevealPassword] = useState("");
  const [revealLoading, setRevealLoading] = useState(false);
  const [revealError, setRevealError] = useState("");
  const [revealedKeys, setRevealedKeys] = useState({});
  const [showRevealedKey, setShowRevealedKey] = useState({});
  const [showingDropdownOpen, setShowingDropdownOpen] = useState(false);
  const showingDropdownRef = useRef(null);
  const handleCheckboxChange = (e) => {
    const value = e.target.value;
    if (e.target.checked) {
      setSelectedGateways((prevSelected) => [...prevSelected, value]);
    } else {
      setSelectedGateways((prevSelected) => prevSelected.filter((gateway) => gateway !== value));
    }
  };

  const isGatewaySelected = (gateway) => {
    return selectedGateways.includes(gateway);
  };
  const [activeChange, setActiveChange] = useState(false);

  async function getProfiles() {
    try {
      const response = await axios.get("/api/wise/profile", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const arr = [];
      response.data.map((item) => {
        if (item.type === "business") {
          arr.push(item);
        }
      });

      setProfiles(arr);
    } catch (err) {
      global.config.slackMessage(err.toString());
      console.log(err);
    }
  }


  const [wiseSettings, setWiseSettings] = useState([]);
  const [settingsLoading, setSettingsLoading] = useState(false);

  useEffect(() => {
    const fetchSettingsData = async () => {
      try {
        setSettingsLoading(true);
        setIsLoading(true);

        const response = await axios.get("/api/wise/settings", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setWiseSettings(response.data);
      } catch (error) {
        console.error("Error fetching settings:", error);
      } finally {
        setIsLoading(false);
        setSettingsLoading(false);
      }
    };

    // Non-blocking async call
    const timeoutId = setTimeout(() => {
      fetchSettingsData();
    }, 0);

    // Cleanup timeout on effect unmount or dependency change
    return () => clearTimeout(timeoutId);
  }, [token, isButtonLoading, listUpdate]); // Re-run effect on token change or after add/delete

  useEffect(() => {
    const fetchData = async () => {
      // Deferring the execution of checkActiveProfile and getProfiles
      setTimeout(() => {
        checkActiveProfile();
        getProfiles();
      }, 0);
    };

    fetchData();
  }, []); // This effect will run once on mount, equivalent to componentDidMount

  const handleClickOutsideDropdown = (event) => {
    const isClickInsideShowingDropdown = showingDropdownRef.current && showingDropdownRef.current.contains(event.target);
    if (!isClickInsideShowingDropdown) {
      setShowingDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutsideDropdown);
    return () => {
      document.removeEventListener('click', handleClickOutsideDropdown);
    };
  }, []);

  const checkActiveProfile = async (profileId) => {
    try {
      const response = await axios.get("/api/wise/profile/active-list", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      var profiles = [];
      if (response.data.length > 0) {
        let filtered = response.data.map((item) => {
          return parseInt(item.wise_profile_id);
        });
        setActiveProfiles(filtered);
        return filtered;
      } else {
        return profiles;
      }
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
    }
  };

  const renderUserCTA = (rowData) => {
    const { profile_id, wise_status } = rowData;
    const isActive = !wise_status 
    const isLoading = loadingProfiles[profile_id] || false;

    return (
      <span
        className={`payment-status ${wise_status ? "active" : "inactive"}`}
        onClick={(e) => {
          e.preventDefault();

          if (!isLoading) {

          }

          if (!isLoading) {
            if (isActive) {
              wiseDeactivate(rowData._id);
              setActiveChange(!activeChange);

              // Delay settingsRefetch by 3 seconds
              setTimeout(() => {
                // settingsRefetch();
              }, 3000);
            } else {
              wiseDeactivate(rowData._id);
              setActiveChange(!activeChange);

              // Delay settingsRefetch by 3 seconds
              setTimeout(() => {
                // settingsRefetch();
              }, 3000);
            }
          }
        }}
        style={{ cursor: 'pointer' }}
      >
        {isLoading ? "..." : (
            isActive ? global.config.locate((appSettings && appSettings.language), 'Active') : global.config.locate((appSettings && appSettings.language), 'Inactive')
          )}
      </span>
    );
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value)
  };

  const filteredData = wiseSettings.length > 0 && wiseSettings.filter((item) => {

    const searchTerm = filter.trim().toLowerCase();
    if (!isLoading && searchTerm) {
      const hasMatch =
        item.comapny_name?.toLowerCase().includes(searchTerm) ||
        item.comapny_account?.toLowerCase().includes(searchTerm);
      return hasMatch;
    } else {

      return item;
    }

  });

  const wiseActivate = async (profileId) => {
    try {
      setLoadingProfiles((prevLoadingProfiles) => ({
        ...prevLoadingProfiles,
        [profileId]: true,
      }));
      await axios.get(`/api/wise/profile/activate/${profileId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setActiveProfiles((prevActiveProfiles) => [
        ...prevActiveProfiles,
        parseInt(profileId),
      ]);

      setLoadingProfiles((prevLoadingProfiles) => ({
        ...prevLoadingProfiles,
        [profileId]: false,
      }));
      toast.success(`Wise profile ${profileId} activated successfully`, {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      console.error(error);
      global.config.slackMessage(error.toString());
      setLoadingProfiles((prevLoadingProfiles) => ({
        ...prevLoadingProfiles,
        [profileId]: false,
      }));
      toast.error(`Something went wrong while activation of wise profile ${profileId}`, {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const wiseDeactivate = async (profileId) => {

    try {

      const response = await axios.get(`/api/wise/settings/status/toggle/${profileId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      let msg = null;
      if (response.data.wise_status === true) {

        msg = "Activated";
      }

      if (response.data.wise_status === false) {

        msg = "Deactivated";

      }

      toast.success(`Wise profile ${msg} successfully`, {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

    } catch (error) {
      console.error(error);
      global.config.slackMessage(error.toString());
      setLoadingProfiles((prevLoadingProfiles) => ({
        ...prevLoadingProfiles,
        [profileId]: false,
      }));
      toast.error(`Something went wrong while deactivation of wise profile ${profileId}`, {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

    }
  };

  const handleOpenModal = () => {
    setNewBankModel(true);
    setSelectedGateways((prevSelected) => [...prevSelected, "wise"]);
  };

  // Function to open the modal and set the selected profile
  const openRevealModal = (settingsId) => {
    setRevealSettingsId(settingsId);
    setRevealPassword("");
    setRevealError("");
    setRevealModal(true);
  };

  const handleRevealSubmit = async () => {
    if (!revealPassword) { setRevealError("Password required"); return; }
    setRevealLoading(true);
    setRevealError("");
    try {
      const res = await axios.post(
        "/api/wise/reveal-key",
        { settingsId: revealSettingsId, password: revealPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRevealedKeys((prev) => ({ ...prev, [revealSettingsId]: res.data.wise_api_key }));
      setShowRevealedKey((prev) => ({ ...prev, [revealSettingsId]: true }));
      setRevealModal(false);
      setRevealPassword("");
      // Auto-hide after 30 seconds
      setTimeout(() => {
        setShowRevealedKey((prev) => ({ ...prev, [revealSettingsId]: false }));
        setRevealedKeys((prev) => { const n = { ...prev }; delete n[revealSettingsId]; return n; });
      }, 30000);
    } catch (err) {
      const msg = err?.response?.data?.message || "Incorrect password";
      setRevealError(msg);
    } finally {
      setRevealLoading(false);
    }
  };

  const humanizeEnum = (str) => {
    if (!str) return "";
    return str
      .split("_")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(" ");
  };

  const openModal = async (profile) => {
    const profileId = profile.profile_id;
    const settingsId = profile._id;

    setIsLoadingDetails((prev) => ({ ...prev, [profileId]: true }));

    try {
      // Fetch fresh profile list and active invoice count in parallel
      const [profilesRes, invoiceRes] = await Promise.all([
        axios.get("/api/wise/profile", {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.post(`/api/wise/profile/check-active-invoices`, {
          comapny_account: profile.comapny_account,
        }),
      ]);

      const freshProfiles = profilesRes.data || [];
      const matched = freshProfiles.find(
        (item) => String(item.id) === String(profileId)
      );

      if (matched) {
        matched.activeCount = invoiceRes.data;
        matched.settingsId = settingsId;
        setSelectedProfile(matched);
        setIsModalOpen(true);
      } else {
        alert("Profile details not found. Please check the Wise API connection.");
      }
    } catch (error) {
      console.error(error);
      global.config.slackMessage(error.toString());
      alert("Something went wrong while loading details.");
    } finally {
      setIsLoadingDetails((prev) => ({ ...prev, [profileId]: false }));
    }
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleCloseModal = () => {
    setNewBankModel(false);
    setSelectedGateways([]);
    setStepTwo(false);
  };

  const handleSubmit1 = (event) => {
    event.preventDefault();
    setErrorMessage(null);
    setStepTwo(true);
  };

  const handleSubmit2 = async (event) => {

    event.preventDefault();

    const hasUrlError = !url || !isValid;
    const hasApiKeyError = !setApiKey || setApiKey.trim() === "";
    setUrlError(hasUrlError);
    setApiKeyError(hasApiKeyError);
    if (hasUrlError || hasApiKeyError) return;

    seIsButtonLoading(true);

    try {
      const validationResponse = await axios.post(
        "/api/wise/api-check",
        { token: setApiKey },
        {
          headers: {
            'Authorization': `Bearer ${token}`, // Add Bearer token in the header
          },
        }
      );

      // Check if the API key is valid
      if (validationResponse.data.valid) {
        const profile_id = validationResponse.data.data; // Extract profile ID from response

        // Save the validated API key and profile ID
        await axios
          .post("/api/wise/add", {
            wise_api_key: setApiKey,
            wise_url: url,
            wise_status: true,
            appId: appId,
            company_account: null,
            company_name: null,
            profile_id: profile_id,
          })
          .then((response) => {
            if (response.data.status === "exists") {
              setErrorMessage(response.data.message);
            } else {
              seIsButtonLoading(false);
              setNewBankModel(false);
              setStepTwo(false);
              setSetApiKey(null);
              setListUpdaete(!listUpdate);
            }
          })
          .catch((error) => {
            console.error(error);
            global.config.slackMessage(error.toString());
            seIsButtonLoading(false);
            setErrorMessage("API Key already exists.");
            
          });
      } else {
        // Handle invalid API key
        seIsButtonLoading(false);
        setErrorMessage("Invalid API Key. Please check and try again.");
      }
    } catch (error) {
      console.error(error);
      global.config.slackMessage(error.toString());
      seIsButtonLoading(false);
      setErrorMessage("Error validating API Key.");
    }

    seIsButtonLoading(false);

  };

  const renderDetailButton = (rowData) => {
    const profileId = rowData.profile_id;
    const loading = isLoadingDetails[profileId];

    return (
      <button
        className="cta-link account-payment"
        onClick={() => openModal(rowData)}
        style={{ minWidth: "80px", position: "relative" }}
        disabled={loading}
      >
        <span style={{ visibility: loading ? "hidden" : "visible" }}>
          {global.config.locate(appSettings && appSettings.language, 'Details')}
        </span>
        {loading && (
          <span style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)", letterSpacing: "2px" }}>
            ···
          </span>
        )}
      </button>
    );
  };

  const handleDelete = () => {
    setIsDeleteModalOpen(true);
  };

  const handleCancelDelete = () => {
    setIsDeleteModalOpen(false);
  };

  const handleInputChange = (event) => {
    const inputUrl = event.target.value;
    setUrl(inputUrl);
    setIsValid(validator.isURL(inputUrl));
  };

  const deleteAccount = async (settingsId) => {
    try {
      await axios.get(`/api/wise/settings/delete/${settingsId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setIsDeleteModalOpen(false);
      setIsModalOpen(false);
      setListUpdaete(!listUpdate);
      toast.success("Account deleted successfully.");
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete account.");
    }
  };

  const totalResults = filteredData && filteredData.length;

  return (
    <div className="user-outer-overview add-bank-account bank-account-new-type">
      <div className="invoice-top">
        <div className="invoice-top-inner-left">
          <BankAccount />
          <div className="search-sec">
            <div className="search-container">
              <input
                type="text"
                onChange={handleFilterChange}
                value={filter}
                className="search-input"
                placeholder='Search by name'
              />
            </div>
          </div>
        </div>
        <div className="button-sec-invoice">
          <Link onClick={handleOpenModal}>
            <span className="icon-invoice">
              <img src={PlusIcon} alt="Add" />
            </span>
            {global.config.locate(appSettings && appSettings.language, 'New_Bank_Account')}
          </Link>

          <Modal
            isOpen={newBankModal}
            onRequestClose={handleCloseModal}
            className="client-modal sprint-modal add-bank-account-modal account-details-modal"
            contentLabel="Invite a User"
            style={{
              content: {
                height: "41%",
                width: "30%",
                position: "fixed",
                top: "50%",
                left: "50%",
              },
            }}
          >
            <div className="modal add-bank-account-content account-details-modal-inner">
              <div className="modal-close-invite outter-modal-main">
                <Link className="" onClick={handleCloseModal}>
                  <img src={Close} alt="Edit Icon" />{" "}
                </Link>
              </div>
              <div className="modal-invite-head">
                <h2 className=""> {global.config.locate(appSettings && appSettings.language, 'New_Bank_Account')} </h2>
              </div>
              <div className="progress-bar">
                {stepTwo === false ? (
                  <progress value="1" max="2" />
                ) : (
                  <progress value="2" max="2" />
                )}
              </div>

              {stepTwo === false ? (
                <form onSubmit={handleSubmit1}>
                  <div>
                    <div className="the-modal-inuser">
                      <label htmlFor="grid-password">
                        <p className="step-head">{global.config.locate(appSettings && appSettings.language, 'Step1')}</p>
                        <p className="step-description">{global.config.locate(appSettings && appSettings.language, 'Please_select_the_bank')}</p>
                      </label>
                      <div className="account-bank-outer">
                        <div className="account-bank-inner">
                          <label className="checkbox-container">
                            <input
                              type="radio"
                              name="gateway"
                              value="wise"
                              className="hidden-checkbox"
                              required
                              onChange={handleCheckboxChange}
                              checked={isGatewaySelected('wise')}
                            />
                            <span className="checkbox-logo" style={{ backgroundImage: `url(${Wise})` }}></span>
                          </label>
                        </div>
                        <div className="account-bank-inner" style={{ opacity: 0.35, pointerEvents: "none" }}>
                          <label className="checkbox-container">
                            <input
                              type="radio"
                              name="gateway"
                              value="another-gateway"
                              className="hidden-checkbox"
                              required
                              disabled
                              onChange={handleCheckboxChange}
                              checked={isGatewaySelected('another-gateway')}
                            />
                            <span className="checkbox-logo" style={{ backgroundImage: `url(${Chase})` }}></span>
                          </label>
                        </div>
                        <div className="account-bank-inner" style={{ opacity: 0.35, pointerEvents: "none" }}>
                          <label className="checkbox-container">
                            <input
                              type="radio"
                              name="gateway"
                              value="another-gateway"
                              className="hidden-checkbox"
                              required
                              disabled
                              onChange={handleCheckboxChange}
                              checked={isGatewaySelected('another-gateway')}
                            />
                            <span className="checkbox-logo" style={{ backgroundImage: `url(${BankAmerica})` }}></span>
                          </label>
                        </div>
                        <div className="account-bank-inner" style={{ opacity: 0.35, pointerEvents: "none" }}>
                          <label className="checkbox-container">
                            <input
                              type="radio"
                              name="gateway"
                              value="another-gateway"
                              className="hidden-checkbox"
                              required
                              disabled
                              onChange={handleCheckboxChange}
                              checked={isGatewaySelected('another-gateway')}
                            />
                            <span className="checkbox-logo" style={{ backgroundImage: `url(${Bac})` }}></span>
                          </label>
                        </div>
                        <div className="account-bank-inner" style={{ opacity: 0.35, pointerEvents: "none" }}>
                          <label className="checkbox-container">
                            <input
                              type="radio"
                              name="gateway"
                              value="another-gateway"
                              className="hidden-checkbox"
                              required
                              disabled
                              onChange={handleCheckboxChange}
                              checked={isGatewaySelected('another-gateway')}
                            />
                            <span className="checkbox-logo" style={{ backgroundImage: `url(${Hsbc})` }}></span>
                          </label>
                        </div>
                        <div className="account-bank-inner" style={{ opacity: 0.35, pointerEvents: "none" }}>
                          <label className="checkbox-container">
                            <input
                              type="radio"
                              name="gateway"
                              value="another-gateway"
                              className="hidden-checkbox"
                              required
                              disabled
                              onChange={handleCheckboxChange}
                              checked={isGatewaySelected('another-gateway')}
                            />
                            <span className="checkbox-logo" style={{ backgroundImage: `url(${Citi})` }}></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="invite-mail-popup-btn">
                    <button type="submit" className="">
                      {global.config.locate(appSettings && appSettings.language, 'Continue')}
                    </button>
                  </div>
                </form>
              ) : (
                <form onSubmit={handleSubmit2}>
                  <div>
                    <div className="the-modal-inuser">
                      <label htmlFor="grid-password" className="">
                        <p className="step-head">{global.config.locate(appSettings && appSettings.language, 'Step2')}</p>
                        <p className="step-description">{global.config.locate(appSettings && appSettings.language, 'Please_fill_out_the_following_information')}</p>
                      </label>
                      <div className="flex items-center">

                        <div className="form-step2">
                          <label>URL</label>
                          <input
                            type="text"
                            value={url}
                            placeholder="ex: https://api.transferwise.com"
                            style={urlError ? { borderColor: "#e53535", backgroundColor: "#fff5f5" } : {}}
                            onChange={(e) => { handleInputChange(e); setUrlError(false); }} />
                          {urlError && <span style={{ color: "#e53535", fontSize: "12px" }}>Valid URL required</span>}
                          {!urlError && <span style={{ color: "#e53535", fontSize: "12px" }}>{isValid ? '' : 'Invalid URL'}</span>}
                        </div>
                        <div className="form-step2">
                          <label>API-Key</label>
                          <input
                            type="text"
                            name="gateway"
                            value={setApiKey}
                            className=""
                            placeholder="API Key"
                            style={apiKeyError ? { borderColor: "#e53535", backgroundColor: "#fff5f5" } : {}}
                            onInput={(e) => { setSetApiKey(e.target.value.trim()); setApiKeyError(false); }}
                          />
                          {apiKeyError && <span style={{ color: "#e53535", fontSize: "12px" }}>API Key required</span>}
                        </div>
                      </div>
                    </div>
                    <span style={{ color: "red" }}>{errorMessage}</span>
                  </div>
                  <div className="invite-mail-popup-btn">
                    {isButtonLoading ?
                      (<button type="button" className="" disabled>...</button>)
                      :
                      (<button type="submit" className="">
                        {global.config.locate(appSettings && appSettings.language, 'Continue')}
                      </button>)
                    }
                  </div>
                </form>
              )}
            </div>
          </Modal>
        </div>
      </div>
      <div className="showing-count">
        <div className="filter-inner showing-result">
          <label>{global.config.locate(appSettings && appSettings.language, 'Showing')}</label>
          <div ref={showingDropdownRef} className="select-modal-mainM custom-dropdown-user-new-outer">
            <div className="selected-option custom-dropdown-user-new" onClick={() => setShowingDropdownOpen(!showingDropdownOpen)}>
              {totalResults < 10 ? totalResults.toString() : perPage.toString()}
            </div>
            {showingDropdownOpen && (
              <div className="custom-dropdown-new">
                <ul className="showing-options-list">
                  {totalResults >= 10 && <li className={perPage === 10 ? 'selected-item' : ''} onClick={() => { setPerPage(10); setShowingDropdownOpen(false); }}>10</li>}
                  {totalResults >= 20 && <li className={perPage === 20 ? 'selected-item' : ''} onClick={() => { setPerPage(20); setShowingDropdownOpen(false); }}>20</li>}
                  {totalResults >= 30 && <li className={perPage === 30 ? 'selected-item' : ''} onClick={() => { setPerPage(30); setShowingDropdownOpen(false); }}>30</li>}
                  {totalResults >= 40 && <li className={perPage === 40 ? 'selected-item' : ''} onClick={() => { setPerPage(40); setShowingDropdownOpen(false); }}>40</li>}
                  {totalResults >= 10 && <li className={totalResults >= 10 && perPage === totalResults ? 'selected-item' : ''} onClick={() => { setPerPage(totalResults); setShowingDropdownOpen(false); }}>ALL</li>}
                  {/* Add more conditions as needed */}
                  {totalResults < 10 ? (
                    <li className={totalResults < 10 ? 'selected-item' : ''} onClick={() => { setPerPage(totalResults); setShowingDropdownOpen(false); }}>{totalResults}</li>
                  ) : null}
                </ul>
              </div>
            )}
          </div>
          <label>{global.config.locate(appSettings && appSettings.language, 'of')} {totalResults} {global.config.locate(appSettings && appSettings.language, 'Results')}</label>
        </div>
      </div>

      <div className="card-outer1">
        <div className="card-outer card-outer-account">
          <div className="card-outer-user">

          </div>
          <div className="modal-invite-main-outter modal-add-bank-account">
            <Modal
              isOpen={isModalOpen}
              onRequestClose={closeModal}
              className="client-modal sprint-modal add-bank-account-modal add-bank-account-modal-details"
              contentLabel="Invite a User"
              style={{
                content: {
                  width: "32%",
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  maxHeight: "85vh",
                  overflowY: "auto",
                },
              }}
            >
              <div className="modal timeoff-review account-detail-inner-sec">
                <div className="modal-close-invite outter-modal-main">
                  <a className="" onClick={closeModal}>
                    <img src={crssrImage} alt="Edit Icon" />{" "}
                  </a>
                </div>
                <div className="modal-client-head">
                  <h2 className="">{global.config.locate(appSettings && appSettings.language, 'Account_Details')} </h2>
                </div>
                <div className="form-field-client-outer">
                  <div className="form-field-client">
                    <label className="form-label">
                      <div className="icon-before-time">
                        <img src={Bank} alt="bank" />
                      </div>
                      {global.config.locate(appSettings && appSettings.language, 'Bank')}
                    </label>
                    <div className="timeoff-user-inner">
                      <img src={WiseSmall} alt="Wise" />
                    </div>
                  </div>
                  <div className="form-field-client">
                    <label className="form-label" >
                      <div className="icon-before-time">
                        <img src={Type} alt="type" />
                      </div>
                      {global.config.locate(appSettings && appSettings.language, 'Name')}
                    </label>
                    {selectedProfile?.businessName || selectedProfile?.fullName}

                  </div>
                  <div className="form-field-client">
                    <label className="form-label" >
                      <div className="icon-before-time">
                        <img src={Type} alt="type" />
                      </div>
                      {global.config.locate(appSettings && appSettings.language, 'Registration_Number')}
                    </label>
                    {selectedProfile?.registrationNumber}
                  </div>
                  <div className="form-field-client">
                    <label className="form-label">
                      <div className="icon-before-time">
                        <img src={CompanyType} alt="CompanyType" />
                      </div>
                      {global.config.locate(appSettings && appSettings.language, 'Company_Type')}
                    </label>
                    {humanizeEnum(selectedProfile?.companyType)}
                  </div>
                  <div className="form-field-client">
                    <label className="form-label" >
                      <div className="icon-before-time">
                        <img src={Type} alt="role" />
                      </div>
                      {global.config.locate(appSettings && appSettings.language, 'Company_Role')}
                    </label>
                    {humanizeEnum(selectedProfile?.companyRole)}
                  </div>
                  <div className="form-field-client">
                    <label className="form-label" >
                      <div className="icon-before-time">
                        <img src={Type} alt="Type" />
                      </div>
                      {global.config.locate(appSettings && appSettings.language, 'Description_of_Business')}
                    </label>
                    {humanizeEnum(selectedProfile?.descriptionOfBusiness)}
                  </div>
                  <div className="form-field-client">
                    <label className="form-label" >
                      <div className="icon-before-time">
                        <img src={Location} alt="Location" />
                      </div>
                      {global.config.locate(appSettings && appSettings.language, 'Primary_Address')}
                    </label>
                    {selectedProfile?.address
                      ? `${selectedProfile.address.addressFirstLine}, ${selectedProfile.address.city}, ${selectedProfile.address.postCode}, ${selectedProfile.address.countryIso2Code}`
                      : ""}
                  </div>
                  <div className="form-field-client">
                    <label className="form-label" >
                      <div className="icon-before-time">
                        <img src={WebPage} alt="Webpage" />
                      </div>
                      {global.config.locate(appSettings && appSettings.language, 'Webpage')}
                    </label>
                    {selectedProfile?.webpage ? (
                      <a href={`https://${selectedProfile.webpage.replace(/^https?:\/\//, "")}`} target="_blank" rel="noopener noreferrer" style={{ color: "#405BFF", textDecoration: "none" }}>
                        {selectedProfile.webpage}
                      </a>
                    ) : ""}
                  </div>
                  <div className="form-field-client">
                    <label className="form-label" >
                      <div className="icon-before-time">
                        <img src={Type} alt="Description" />
                      </div>
                      {global.config.locate(appSettings && appSettings.language, 'Description_Category')}
                    </label>
                    {humanizeEnum(selectedProfile?.firstLevelCategory)}
                  </div>
                  {selectedProfile?.email && (
                    <div className="form-field-client">
                      <label className="form-label">
                        <div className="icon-before-time">
                          <img src={Type} alt="Email" />
                        </div>
                        Email
                      </label>
                      {selectedProfile.email}
                    </div>
                  )}
                  <div className="form-field-client-btns delete-timeoff delete-account-details">
                    <button
                      type="button"
                      className="delete-client"
                      onClick={() => handleDelete(selectedProfile && selectedProfile.settingsId)}
                    >
                      <img src={Delete} alt="Delete" /> {global.config.locate(appSettings && appSettings.language, 'Delete_Account')}
                    </button>
                    <Modal
                      className="delete-modal"
                      isOpen={isDeleteModalOpen}
                      onRequestClose={handleCancelDelete}
                      contentLabel="Confirm Delete"
                      style={{ content: { height: "41%", width: "30%", position: "fixed", top: "40%", left: "50%" } }}
                    >
                      <div className="delete-modal-content">
                        <div className="outter-modal-main">
                          <a className="close-image-clr1" onClick={handleCancelDelete}>
                            <img src={crssrImage} alt="Close" />
                          </a>
                        </div>
                        <h2>Delete Bank Account?</h2>
                        {selectedProfile && selectedProfile.activeCount === 0 ? (
                          <p>Are you sure you want to delete this account? This action cannot be undone.</p>
                        ) : (
                          <p>This account has {selectedProfile?.activeCount} unpaid invoice(s). Please complete or remove them before deleting.</p>
                        )}
                        <div className="delete-modal-buttons">
                          {selectedProfile && selectedProfile.activeCount === 0 && (
                            <button className="delete" onClick={() => deleteAccount(selectedProfile.settingsId)}>
                              Yes, Delete
                            </button>
                          )}
                          <button onClick={handleCancelDelete}>Cancel</button>
                        </div>
                      </div>
                    </Modal>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
          <div className="card">
            {settingsLoading === true ? (
              <div 
                className="p-datatable p-component p-datatable-responsive-scroll"
                style={{ marginBottom: 0, paddingBottom: 0 }}
              >
                <div 
                  className="p-datatable-wrapper"
                  style={{ paddingBottom: 0, marginBottom: 0 }}
                >
                  <table
                    className="p-datatable-table"
                    style={{ 
                      minWidth: "50rem", 
                      width: "100%", 
                      textAlign: "left",
                      marginBottom: 0,
                      borderSpacing: 0,
                    }}
                  >
                    <thead className="p-datatable-thead">
                      <tr>
                        <th style={{ 
                          paddingRight: "44px", 
                          maxWidth: "297px", 
                          textAlign: "left", 
                          paddingLeft: "22px",
                          paddingTop: "11px",
                          paddingBottom: "12px",
                          background: "#F5F6F8",
                          fontWeight: 500,
                          fontSize: "17px",
                          lineHeight: "21px",
                          color: "#6A7988",
                          borderTopLeftRadius: "10px",
                          borderBottomLeftRadius: "10px"
                        }}>{global.config.locate(appSettings && appSettings.language, 'Company_name')}</th>
                        <th style={{ 
                          paddingRight: "20px", 
                          textAlign: "left",
                          paddingTop: "11px",
                          paddingBottom: "12px",
                          background: "#F5F6F8",
                          fontWeight: 500,
                          fontSize: "17px",
                          lineHeight: "21px",
                          color: "#6A7988"
                        }}>{global.config.locate(appSettings && appSettings.language, 'Company_Account')}</th>
                        <th style={{ 
                          paddingRight: "44px", 
                          textAlign: "left",
                          paddingTop: "11px",
                          paddingBottom: "12px",
                          background: "#F5F6F8",
                          fontWeight: 500,
                          fontSize: "17px",
                          lineHeight: "21px",
                          color: "#6A7988"
                        }}>API Key</th>
                        <th style={{ 
                          paddingRight: "44px", 
                          textAlign: "left",
                          paddingTop: "11px",
                          paddingBottom: "12px",
                          background: "#F5F6F8",
                          fontWeight: 500,
                          fontSize: "17px",
                          lineHeight: "21px",
                          color: "#6A7988"
                        }}>{global.config.locate(appSettings && appSettings.language, 'Status')}</th>
                        <th style={{ 
                          width: "76px", 
                          textAlign: "center", 
                          paddingRight: "22px",
                          paddingTop: "11px",
                          paddingBottom: "12px",
                          background: "#F5F6F8",
                          fontWeight: 500,
                          fontSize: "17px",
                          lineHeight: "21px",
                          color: "#6A7988",
                          borderTopRightRadius: "10px",
                          borderBottomRightRadius: "10px"
                        }}></th>
                      </tr>
                    </thead>
                    <tbody className="p-datatable-tbody" style={{ marginBottom: 0, paddingBottom: 0 }}>
                      {Array.from({ length: perPage }).map((_, index) => (
                        <tr key={`skeleton-${index}`}>
                          {/* Company name */}
                          <td style={{ 
                            paddingRight: "44px", 
                            maxWidth: "297px", 
                            paddingLeft: "22px",
                            paddingTop: "19px",
                            paddingBottom: "22px",
                            borderBottom: "0.5px solid #d8dde1"
                          }}>
                            <div
                              style={{
                                width: "200px",
                                height: "20px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            />
                          </td>
                          {/* Company Account */}
                          <td style={{ 
                            paddingRight: "20px",
                            paddingTop: "19px",
                            paddingBottom: "22px",
                            borderBottom: "0.5px solid #d8dde1"
                          }}>
                            <div
                              style={{
                                width: "150px",
                                height: "20px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            />
                          </td>
                          {/* API Key */}
                          <td style={{ 
                            paddingRight: "44px",
                            paddingTop: "19px",
                            paddingBottom: "22px",
                            borderBottom: "0.5px solid #d8dde1"
                          }}>
                            <div
                              style={{
                                width: "180px",
                                height: "20px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            />
                          </td>
                          {/* Status */}
                          <td style={{ 
                            paddingRight: "44px",
                            paddingTop: "19px",
                            paddingBottom: "22px",
                            borderBottom: "0.5px solid #d8dde1"
                          }}>
                            <div
                              style={{
                                width: "80px",
                                height: "24px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            />
                          </td>
                          {/* Actions */}
                          <td style={{ 
                            width: "76px", 
                            textAlign: "center", 
                            paddingRight: "22px",
                            paddingTop: "19px",
                            paddingBottom: "22px",
                            borderBottom: "0.5px solid #d8dde1"
                          }}>
                            <div
                              style={{
                                width: "60px",
                                height: "24px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                                margin: "0 auto",
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <DataTable
                value={filteredData}
                removableSort
                tableStyle={{
                  minWidth: "50rem",
                  width: "100%",
                  textAlign: "left",
                }}
                paginator={filteredData && filteredData.length > perPage}
                paginatorClassName="recent-invoices-pagination"
                rows={perPage}
              >
                <Column
                  body={(rowData) => rowData.comapny_name || 'N/A'}
                  field="comapny_name"
                  sortField="id"
                  header={global.config.locate(appSettings && appSettings.language, 'Company_name')}
                  sortable
                  style={{ paddingRight: "44px", maxWidth: "297px" }}
                ></Column>
                <Column
                  body={(rowData) => rowData.comapny_account || 'N/A'}
                  field="comapny_account"
                  header={global.config.locate(appSettings && appSettings.language, 'Company_Account')}
                  sortable
                  style={{ paddingRight: "20px" }}
                ></Column>
                <Column
                  header="API Key"
                  style={{ paddingRight: '44px' }}
                  body={(rowData) => {
                    const id = rowData._id;
                    const revealed = showRevealedKey[id];
                    const key = revealedKeys[id];
                    return (
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span style={{ fontFamily: "monospace", fontSize: "13px", color: "#454F59", userSelect: revealed ? "text" : "none" }}>
                          {revealed && key ? key : (rowData.wise_api_key || "••••••••••••••••••••••••••••")}
                        </span>
                        <button
                          onClick={() => revealed ? (setShowRevealedKey((p) => ({ ...p, [id]: false }))) : openRevealModal(id)}
                          title={revealed ? "Hide API Key" : "Reveal API Key"}
                          style={{ background: "none", border: "none", cursor: "pointer", padding: "2px", color: "#96A8BA", flexShrink: 0 }}
                        >
                          {revealed ? (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                          ) : (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                          )}
                        </button>
                      </div>
                    );
                  }}
                ></Column>
                <Column
                  header={global.config.locate(appSettings && appSettings.language, 'Status')}
                  body={renderUserCTA}
                  sortable
                  style={{ paddingRight: "44px" }}
                ></Column>
                <Column
                  body={renderDetailButton}
                  style={{ width: "76px", textAlign: "center" }}
                ></Column>
              </DataTable>
            )}
          </div>
        </div>
      </div>

      <Modal
        className="delete-modal"
        isOpen={revealModal}
        onRequestClose={() => { setRevealModal(false); setRevealPassword(""); setRevealError(""); }}
        contentLabel="Reveal API Key"
        style={{ content: { height: "auto", width: "30%", position: "fixed", top: "40%", left: "50%" } }}
      >
        <div className="delete-modal-content">
          <div className="outter-modal-main">
            <a className="close-image-clr1" onClick={() => { setRevealModal(false); setRevealPassword(""); setRevealError(""); }}>
              <img src={crssrImage} alt="Close" />
            </a>
          </div>
          <h2>Confirm Your Identity</h2>
          <p>Enter your password to reveal the API key.</p>
          <div style={{ marginTop: "16px" }}>
            <input
              type="password"
              placeholder="Your password"
              value={revealPassword}
              onChange={(e) => { setRevealPassword(e.target.value); setRevealError(""); }}
              onKeyDown={(e) => e.key === "Enter" && handleRevealSubmit()}
              style={{
                width: "100%",
                padding: "10px 14px",
                borderRadius: "8px",
                border: revealError ? "1px solid #e53535" : "1px solid #d9d9d9",
                backgroundColor: revealError ? "#fff5f5" : "#fff",
                fontSize: "14px",
                outline: "none",
                boxSizing: "border-box",
              }}
              autoFocus
            />
            {revealError && <span style={{ color: "#e53535", fontSize: "12px", marginTop: "4px", display: "block" }}>{revealError}</span>}
          </div>
          <div className="delete-modal-buttons" style={{ marginTop: "20px" }}>
            <button
              className="buttons-approved"
              onClick={handleRevealSubmit}
              disabled={revealLoading}
              style={{ minWidth: "100px" }}
            >
              {revealLoading ? "Checking..." : "Reveal Key"}
            </button>
            <button onClick={() => { setRevealModal(false); setRevealPassword(""); setRevealError(""); }}>Cancel</button>
          </div>
        </div>
      </Modal>

    </div>
  )
}

export default PaymentOption;